import { createSelector } from '@ngrx/store';
import { DataSchemaWithRelations } from '@rappider/rappider-sdk';


export const selectDataSchemaById = (dataSchemaId: string) => createSelector(
  state => state['dataSchema']?.data,
  (dataSchemas: DataSchemaWithRelations[]) => dataSchemas?.length ? dataSchemas.find(dataSchema => dataSchema.id === dataSchemaId) : null
);
